import {useState,useEffect, useRef} from 'react'; 
import { Toast } from "primereact/toast";
import { Link } from 'react-router';
import {Tablescom} from '../../components/tablescomp';
import { Tag } from 'primereact/tag';
import  Bredcrum  from '../../components/bredcrum';
import {Titlebar,Searchbox,Confirmdelete,Billofmaterialstatus} from  '../../components/fieldsComp';
import {Progressspinner,Progressspinnerimg} from  '../../components/loaderComp';
import { BrowserRouter, Routes, Route, useNavigate   } from "react-router";
import {productservices} from '../../services/productServices';
import { Dialog } from 'primereact/dialog';
import {localurl} from '../../constant';
import {convertFileToBase64} from '../../helpers/base64conversion';

const Bom = () => {
   const toast = useRef(null);
  const navigate = useNavigate(); 
  const [results,setResults] = useState([]);
  const [ingredients,setIngredients] = useState([]);
  const [ingredientloaded,setIngredientloaded] = useState(true);
  const [userloaded,setUserLoaded] = useState(true);
  const [visible,setVisible] = useState(false);
  const [quickFilterText, setQuickFilterText] = useState('');
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5); // 🔄 dynamic page size
  const [popvisible,setPopvisible] = useState(false);
  const [deleleteid,setDeleleteid] = useState(0);

    useEffect(()=>{
      getbillofmaterial(currentPage,pageSize);
    },[currentPage,pageSize]); 

    useEffect(() => {
      setColDefs(getColDefs(currentPage, pageSize));
  }, [currentPage, pageSize]);


      const handleNext = () => {
      if (currentPage < Math.ceil(totalRows / pageSize)) {
        setCurrentPage(currentPage + 1);
      }
    };
  
    const handlePrevious = () => {
      if (currentPage > 1) {
        setCurrentPage(currentPage - 1);
      }
    };


  const approval = (params,status) =>{
    let id = params.data.id;
    let obj = {
        "id": id,
        "status" : status
    };
    productservices.updatestatus(obj).then((response)=>{
        if(response.status == 200){
             toast.current.show({ severity: 'success', summary: 'Bill of material', detail: `${response.data.data}` }); 
             getbillofmaterial(currentPage,pageSize);
              // setSubmitted(true);
        }else{
             toast.current.show({ severity: 'error', summary: 'Bill of material', detail: `${response.data.data}` }); 
              // setSubmitted(true);
        }
    }).catch((error)=>{
         
    })

  }  
  
  const getColDefs = (currentPage, pageSize) => [
    {
      headerName: "SR NO",
      width:100,
      valueGetter: (params) => {
        return ((currentPage - 1) * pageSize) + params.node.rowIndex + 1;
      },
    },
    { headerName: "Product Name",field: "product_name" },
      { headerName: "Master SKU Code",field: "sku_code",cellRenderer: (params) => {
          return (
              params.getValue()
              // <Tag severity="success" value={params.getValue()} rounded></Tag>
           
          );
        } },

         { headerName: "Bom created",field: "",cellRenderer: (params) => {
          return (
            //  params.data.
            <>{params.data.isapproved == 'approved' ? <span className='text-success fw-bold'>Created</span> : <span className='text-danger'>In Pending</span>}</>
           
          );
        } },
        { headerName: "Approved",field: "isapproved",cellRenderer: (params) => {
          return (
            //  <Billofmaterialstatus status={params.getValue()}/> 
            <>
              <select className='rounded w-100 text-primary dropdown-custom-style' value={params.getValue()} 
              onChange={(e) => { approval(params,e.target.value) }}
              >
                <option value="approved">Approved</option>
                <option value="unapproved">Disapproved</option>
              </select>
            </>
          );
        } },
         { headerName: "Notes",field: "notes" },
      
      { headerName: "Action",
      cellRenderer: (params) => {
        // console.log("params");
        // console.log(params.data.id);
        return (
          <>
               
               {(<button class="btn btn-xs btn-primary btn-border-none custom-btn-color2" 
               disabled={params.data.isapproved == 'approved' ? true : false}
               onClick={()=>navigate('/editbom',{state:params.data.id})}>
                <i class="icon icon-note  color-white"></i>
                </button>)}
                &nbsp;
                <button class="btn btn-danger btn-xs btn-white btn-border-none" disabled={params.data.isapproved == 'approved' ? true : false} onClick={(e) => deletebom(params.data.id)}><i class="icon icon-trash  color-white"></i></button> 
                &nbsp;
                <button class="btn btn-success btn-xs btn-white btn-border-none" onClick={() => getDetail(params.data.product_id)}><i class="icon icon-eye  color-white"></i></button> 
               
          </>
         
        );
      } }
  ];
  
  const [colDefs, setColDefs] = useState(getColDefs(1, 5));

  // const [colDefs, setColDefs] = useState([
  //     { headerName: "SR NO",field: "id", width: 100 },
  //     { headerName: "Product Name",field: "product_name" },
  //     { headerName: "Master SKU Code",field: "sku_code",cellRenderer: (params) => {
  //         return (
  //             <Tag severity="success" value={params.getValue()} rounded></Tag>
           
  //         );
  //       } },
      
  //     { headerName: "Action",
  //     cellRenderer: (params) => {
  //       // console.log("params");
  //       // console.log(params.data.id);
  //       return (
  //         <>
               
  //              <button class="btn  btn-xs btn-primary btn-border-none custom-btn-color2" onClick={()=>navigate('/editbom',{state:params.data})}>
  //               <i class="icon icon-note icon-style color-white"></i>
  //               </button>
  //               &nbsp;
  //               <button class="btn btn-danger btn-xs btn-white btn-border-none"><i class="icon icon-trash icon-style color-white"></i></button> 
  //               &nbsp;
  //               <button class="btn btn-success btn-xs btn-white btn-border-none" onClick={() => getDetail(params.data.product_id)}><i class="icon icon-eye icon-style color-white"></i></button> 
               
  //         </>
         
  //       );
  //     } }
  //   ]);

 

    function getbillofmaterial(page,pageSize){
        setUserLoaded(true);
        productservices.getbillofmaterial(page,pageSize).then((response)=>{
             if(response.status == 200){
                 setResults(response.data.data); 
                setTotalRows(response.data.total);
                setCurrentPage(response.data.current_page); 
                 setUserLoaded(false);
             }else{
                 setResults([]);
                 setUserLoaded(false);
             } 
        }).catch((error)=>{
             setResults([]);
             setUserLoaded(false);
        });
    }


   async function getDetail(id){
      setVisible(true);
      setIngredientloaded(false);
      let response = await productservices.getbllofmaterialDetail(id);
      if(response.status == 200){
        //  console.log("response");
         setIngredients(response.data.data);  
         setIngredientloaded(true); 
      }else{
            setIngredients([]);
            setIngredientloaded(true);
      }
   }

   function displayIngredients(){
        let arr = [];
        ingredients.forEach((value,index) =>{
          // console.log(value.component);
            arr.push(<tr> 
                          <td>{index + 1}</td>
                          <td>{value.component}</td>
                          <td>{value.componentSkuCode}</td>
                          <td>{value.billofmaterial_qty} <span className='text-success'>({value.billofmaterial_units})</span></td>
                          {/* <td>{value.billofmaterial_units}</td> */}
                      </tr>);
        })

        return arr;
   }

     const onPaginationChanged = (params) => {
    const gridApi = params.api;
    const newPage = gridApi.paginationGetCurrentPage() + 1;
    if (newPage !== currentPage) {
      setCurrentPage(newPage);
    }
  };

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setCurrentPage(1);           // reset to page 1
    getbillofmaterial(1, newSize);       // reload with new size
  };
    
      const deletebomdata = () => {
            if(deleleteid){
            productservices.deletebom(deleleteid).then((response)=>{
            if(response.status == 200){
              setPopvisible(false);
              setDeleleteid(false);
              toast.current.show({ severity: 'success', summary: 'bom', detail: 'BOM deleted successfully' }); 
              getbillofmaterial(currentPage,pageSize);   
            }
        }).catch((error)=>{
          
        }); 
            }

    }
      const deletebom = (id) =>{
         setPopvisible(true);
         setDeleleteid(id);
      }
      const canceldiag = () =>{
         setPopvisible(false);
      }
  return (
    <>
<Toast ref={toast} />
<Confirmdelete popvisible={popvisible} deletefun={deletebomdata} cancel={canceldiag} title="BOM" />
    {/* <Dialog
        header="⚠️ Confirm Deletion"
        visible={popvisible}
        style={{ width: '30vw', borderRadius: '10px' }}
        onHide={() => setPopvisible(false)}
        modal
      >
        <p className="mb-4" style={{ fontSize: '1rem' }}>
          Are you sure you want to delete this BOM?
        </p>

        <div className="d-flex justify-content-end gap-2">
          <button
            className="btn btn-secondary rounded-pill px-4"
            onClick={() => setPopvisible(false)}
          >
            Cancel
          </button>
          <button
            className="btn btn-danger rounded-pill px-4"
            onClick={deletebomdata}
          >
            Delete
          </button>
        </div>
      </Dialog> */}

          {/* <Bredcrum title={'Bill of material'} divider={false}/> */}
          
          <div class="row">
              <div className='col-md-12 mb-2 mt-2'>
                 <div className='flex-box flex-between'>
                      <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color ' onClick={() => navigate('/addbom')}>Create Bill Of Material</button> 
                      <Searchbox value={quickFilterText} onChange={(e) => setQuickFilterText(e.target.value)} />
                  </div> 
              </div> 

              {/* <Titlebar text={'Bill of Material'}/> */}
              <div className="col-md-12 mt-3">

                   <Dialog visible={visible} position='top' modal style={{ width: '80rem' }} onHide={() => {if (!visible) return; setVisible(false); }}>
                        <div class="container">
                              <table className='table-bordered'>
                                  
                                  <tbody>
                                      <tr>
                                          <th colSpan={4}><h3 className='text-success'>Product : </h3></th>
                                         
                                      </tr>
                                      <tr>
                                          <th>Product Name</th>
                                          <th>Product SKU</th>
                                          <th colSpan={3}></th>
                                      </tr>
                                      <tr>
                                          <td>{ingredients[0]?.product_name}</td>
                                          <td>{ingredients[0]?.product_sku}</td>
                                          <td colSpan={3}></td>
                                      </tr>

                                       <tr>
                                          <th colSpan={4}><h3 className='text-success'>Ingredient Used  : </h3></th>
                                      </tr>
                                      <tr>
                                          <th>Sr No</th>  
                                          <th>Component</th>
                                          <th>Component SKU Code</th>
                                          <th>Bill of Material Qty</th>
                                          {/* <th>Bill of Material Units</th> */}
                                      </tr>
                                      {!ingredientloaded ? (<Progressspinnerimg/>) : displayIngredients()}
                                      
                                  </tbody>
                              </table>     
                        </div>
                  </Dialog>
                  <div className='card'>
                    <div className='card-body card-body-style'>
                       <Tablescom rowdata={results} coldefs={colDefs} isloaded={userloaded} quickFilterText={quickFilterText}
                      paginationPageSize={pageSize} onPaginationChanged={onPaginationChanged}
                     totalRows={totalRows} currentPage={currentPage} pageSize={pageSize} handleNext={handleNext} 
                     handlePrevious={handlePrevious}
                     handlePageSizeChange={handlePageSizeChange}/>
                    </div>
                 </div>
              </div>   
          </div>
       </>
  );
};

export default Bom;
